var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.081,
    height: 27.012,
    viewBox: "0 0 119.081 27.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3176",
    "data-name": "Group 3176",
    transform: "translate(3161.238 -9046.495)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M69.786,10.287v8a4.642,4.642,0,0,1-.626,2.692,2.281,2.281,0,0,1-1.969.856,2.369,2.369,0,0,1-2.021-.874,4.488,4.488,0,0,1-.653-2.675V10.508H60.257v7.783a4.481,4.481,0,0,1-.654,2.675,2.368,2.368,0,0,1-2.021.874,2.265,2.265,0,0,1-1.967-.856,4.567,4.567,0,0,1-.627-2.692v-8H50.727v8.33a6.856,6.856,0,0,0,1.746,5.022,6.781,6.781,0,0,0,5.047,1.774,7.476,7.476,0,0,0,2.841-.485,4.659,4.659,0,0,0,2.022-1.588,4.7,4.7,0,0,0,2.038,1.588,7.436,7.436,0,0,0,2.8.485,6.839,6.839,0,0,0,5.056-1.774,6.8,6.8,0,0,0,1.775-5.022v-8.33Z",
    transform: "translate(-3211.965 9042.791)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M94.838,19.06s.062-1.006.062-1.341a7.443,7.443,0,0,0-1.024-3.98,6.922,6.922,0,0,0-2.744-2.568,8.2,8.2,0,0,0-3.821-.882,8.359,8.359,0,0,0-4.033.971,7.2,7.2,0,0,0-2.815,2.7,7.538,7.538,0,0,0-1.024,3.891,7.462,7.462,0,0,0,1.041,3.909,7.149,7.149,0,0,0,2.947,2.691,9.652,9.652,0,0,0,4.4.962,7.942,7.942,0,0,0,5.5-1.809l-1.377-1.377-.009-.009c-.1-.1-.856-.865-1.041-1.041a5.263,5.263,0,0,1-.618.344l-.318.141a5.559,5.559,0,0,1-2.03.344,5.147,5.147,0,0,1-2.444-.547,3.377,3.377,0,0,1-1.756-2.4Zm-11.1-2.63v-.009a3.652,3.652,0,0,1,.759-1.65,1.512,1.512,0,0,1,.194-.221,3.47,3.47,0,0,1,2.621-1.041,3.73,3.73,0,0,1,2.241.679,3.041,3.041,0,0,1,1.288,2.241Z",
    transform: "translate(-3215.34 9042.79)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M122.894,3.479a2.8,2.8,0,0,0-1.915-.653,2.731,2.731,0,0,0-1.915.679,2.245,2.245,0,0,0-.732,1.7,2.217,2.217,0,0,0,.732,1.694,2.993,2.993,0,0,0,3.83-.009,2.356,2.356,0,0,0,.732-1.765,2.133,2.133,0,0,0-.732-1.642m-4.041,20.844h4.253V9.629h-4.253Z",
    transform: "translate(-3219.913 9043.669)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M140.89,11.928a6.051,6.051,0,0,0-4.412-1.641,7.347,7.347,0,0,0-2.753.5,5.677,5.677,0,0,0-2.109,1.438l-4.068-1.721V25.2h4.262V17.929a4.12,4.12,0,0,1,.953-2.956,3.364,3.364,0,0,1,2.568-1,2.815,2.815,0,0,1,2.215.856,3.832,3.832,0,0,1,.768,2.612V25.2h4.253V16.79a6.477,6.477,0,0,0-1.677-4.862",
    transform: "translate(-3220.997 9042.791)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M152.345,3.479a2.8,2.8,0,0,0-1.915-.653,2.732,2.732,0,0,0-1.915.679,2.244,2.244,0,0,0-.732,1.7,2.217,2.217,0,0,0,.732,1.694,2.993,2.993,0,0,0,3.83-.009,2.356,2.356,0,0,0,.732-1.765,2.133,2.133,0,0,0-.732-1.642M148.3,24.323h4.262V9.629H148.3Z",
    transform: "translate(-3223.376 9043.669)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M164.818,20.735a2.956,2.956,0,0,1-1.747.547,1.711,1.711,0,0,1-1.341-.512,2.033,2.033,0,0,1-.459-1.43V13.032H164.9V9.757h-3.627V3.91h-4.262V19.394a5.164,5.164,0,0,0,1.421,3.936,5.707,5.707,0,0,0,4.068,1.332,7.5,7.5,0,0,0,1.9-.229,4.292,4.292,0,0,0,1.544-.7Z",
    transform: "translate(-3224.461 9043.54)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M179.411,10.537V16.9a4.235,4.235,0,0,1-.927,2.965,3.209,3.209,0,0,1-2.462,1c-1.985,0-2.974-1.2-2.974-3.584V10.537h-4.262v7.368a6.635,6.635,0,0,0,1.694,4.96,6.278,6.278,0,0,0,4.589,1.65,6.515,6.515,0,0,0,2.4-.432,5.556,5.556,0,0,0,1.941-1.262v.494a4.116,4.116,0,0,1-.979,3.009,4.281,4.281,0,0,1-3.115.979,8.706,8.706,0,0,1-2.709-.441,6.932,6.932,0,0,1-2.268-1.2l-1.685,3.062a8.893,8.893,0,0,0,3.1,1.5,14.443,14.443,0,0,0,3.918.521,8.263,8.263,0,0,0,5.956-1.968c1.359-1.315,2.047-3.309,2.047-6.009V10.537Z",
    transform: "translate(-3225.83 9042.762)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M106.807,9.536a7.5,7.5,0,0,0-3.494.856V3.91H99.245V17.1a7.562,7.562,0,1,0,7.562-7.563m0,11.455a3.722,3.722,0,0,1-3.494-2.63,4.025,4.025,0,0,1,0-2.524,3.719,3.719,0,0,1,3.494-2.638,3.8,3.8,0,0,1,3.7,3.9,3.8,3.8,0,0,1-3.7,3.891",
    transform: "translate(-3217.669 9043.54)",
    fill: "#16161a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.660230e794856f04c574882d5daac95f.svg";
export { ForwardRef as ReactComponent };